import { FlexColumn } from '@editor/components/utilities/layouts';
import { Button, menuSmallTheme } from '@repo/ui/components/Buttons';

import { OptionListProps } from './types';

const OptionList: React.FC<OptionListProps> = ({ options }) => {
  return (
    <FlexColumn>
      {options.map((option, index) => {
        const key = option.key || index.toString();
        return (
          <Button
            key={key}
            dataTestId={option.dataTestId || key}
            icon={
              option.icon && {
                component: option.icon,
                height: option.iconHeight,
              }
            }
            isCentered={false}
            label={option.label}
            name={`${option.label}Button`}
            theme={{ ...menuSmallTheme, padding: '8px' }}
            width="100%"
            onClick={option.onClick}
          />
        );
      })}
    </FlexColumn>
  );
};

export default OptionList;
